import React from 'react';
import { Button } from 'react-bootstrap';
import AppSpinner from 'components/common/AppSpinner';

const AppButton = ({
    show = true,
    isBlock = false,
    label = "Button",
    type = null,
    size = null,
    color = "primary", //primary | danger | secondary | success | warning | outline-*
    isLoading = false,
    disabled = false,
    isLoadingLabel = null,
    labelClass = "d-flex align-items-center justify-content-center",
    classes = "",
    icon = null,
    action = () => {},
    ...rest}) => {
    return (
        <>
            {show &&
                <span className={isBlock ? "d-grid" : null}>
                    <Button {...rest} className={classes + " appButton"} type={type} onClick={action}
                        variant={color} size={size} disabled={disabled || isLoading}
                    >
                        <div className={labelClass}>{icon && <>{icon} <span style={{width:4}}/></>} {isLoading ? isLoadingLabel : label}</div>
                    </Button>
                </span>}
        </>
    )
}

AppButton.defaultProps = {
    type: "button",
    size: "sm",
    isLoadingLabel: <AppSpinner color="#FFFFFF" height={20} width={35} />,
}

export default AppButton;